/**
 * OnboardingObs  icash object
 */
import { Country } from "./country";
import { Bank } from "./bank";
import { StatusMigration } from "./enum/statusMigration";
import { BlueBank } from "./blueBank";

export class OnboardingObsicash {
  id: number;
  stage = 0;
  status: string;
  start = false;
  type: string;
  user: any;
  project: any;
  country: Country;
  bank: Bank;
  createNewBankAccount = false;
  // type struct for blueBank onboarding
  blueBank: BlueBank;
  setting: any;
  InitialCurrency: boolean;

  // Struct for  colteFinanciera onboarding
  addressFirstLevelId: number;
  addressFirstLevel?: any;
  addressSecondLevelId: number;
  addressSecondLevel?: number;
  addressDetail: string;
  documentNumber: string;
  documentType: string;
  documentPlatform: string;
  migrationStatus: string;
  economicActivityId: number;
  fundsOriginDeclaration = false;
  fundsOriginId: number;
  jobOccupationId: number;
  purposeId: number;
  termsConditions = false;
  incomeAmount: number;
  expensesAmount: number;
  activesAmount: number;
  passivesAmount: number;
  currencyCode: string;
  bankAccountTypeId: number;
  bankAccountNumber: string;
  reviewReasonEn: string;
  reviewReasonEs: string;
  bankReason: string;

  //didiOnboarding
  countryOfResidenceId:number;
  addressThirdLevelId:number;
  typeOfResidenceId:number;
  addressOfResidence:string;
  telephone:string;
  studyLevelId:number;
  autoridadExpedidora: string;
  autoridadId: string;
  tokenDidi:string;
  formAcceptance: boolean;
  documentTypeDidi:number;
  professionDidi:number;
 maritalStatusDidi:number;
  maritalStatusId:number; //blue
  nationalityId:number; //blue
  occupationId:number; //blue
  professionId:number; //blue
  monthlyIncome:number; // blue
  documentNumberRequestAc:string;
  documentTypeRequestAc:number;
}
